<template>
  <div class="container">
    <Nav></Nav>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-breadcrumb__inner"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/ParkKeeper' }" class="ToParkKeeper"
            >案例展示</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div class="ProductCaseDetail index_center">
      <!--      <div class="ProductCaseDetail_text1 ">{{title}}</div>-->
      <!--      <div class="ProductCaseDetail_text2 paddingBottom">-->
      <!--        <div>客户简介</div>-->
      <!--        <p>{{clientInfo}}</p>-->
      <!--      </div>-->

      <!--      <div class="ProductCaseDetail_text3 paddingBottom">-->
      <!--        <div>案例背景</div>-->
      <!--        <p>{{planBg}}</p>-->
      <!--      </div>-->
      <!--      <div class="ProductCaseDetail_text4 paddingBottom">-->
      <!--        <div class="ProductCaseDetail_text4_txt">策划研发</div>-->
      <!--        <p>{{develop}}</p>-->
      <!--        </div>-->
      <!--      <div class="ProductCaseDetail_text5 paddingBottom">-->
      <!--        <div>成果展示</div>-->
      <!--        <div class="ProductCaseDetail_text5_flex">-->
      <!--          <div class="ProductCaseDetail_text5_img" v-for="item in resultUrls">-->
      <!--              <img :src="item.url" alt="">-->

      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="ProductCaseDetail_text6 paddingBottom">-->
      <!--        <div class="ProductCaseDetail_text6_txt">售后服务</div>-->
      <!--        <p>{{serice}}</p>-->
      <!--      </div>-->
      <!--      <div class="ProductCaseDetail_text7 paddingBottom">-->
      <!--        <div class="ProductCaseDetail_text7_txt"> 客户评价</div>-->
      <!--        <div>{{evaluation}}</div>-->
      <!--      </div>-->
      <div v-html="content"></div>
    </div>
    <SubmitFrom></SubmitFrom>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import SubmitFrom from "./components/SubmitFrom";
import { getProductInfoApi } from "@/api/index";
export default {
  components: { Nav, SubmitFrom },
  data() {
    return {
      id: "",
      clientInfo: "",
      title: "",
      planBg: "",
      develop: "",
      resultUrls: [],
      serice: "",
      evaluation: "",
      content: "",
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getProductInfo();
  },
  methods: {
    //获取产品详情
    getProductInfo() {
      var data = {
        id: this.id,
      };
      getProductInfoApi(data).then((res) => {
        console.log(res);
        this.clientInfo = res.data.clientInfo;
        this.title = res.data.title;
        this.planBg = res.data.planBg;
        this.develop = res.data.develop;
        this.resultUrls = res.data.resultUrls;
        this.serice = res.data.serice;
        this.evaluation = res.data.evaluation;
        this.content = res.data.content;
      });
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.index_center {
  margin: 0 auto;
  min-width: 1200px;
}
.ProductCaseDetail {
  /*max-width: 1360px;*/
  /*background: orange;*/
  width: 1200px;
  margin-top: 70px;
}
.breadcrumb_center {
  background-color: #f6f7f8;
  display: flex;
  /*width: 1200px;*/
  justify-content: space-around;
  height: 50px;
  margin: 0 auto;
}
.el-breadcrumb__inner {
  display: flex;
  align-items: center;
  width: 1200px;
  color: #666666;
}
.el-breadcrumb__inner img {
  padding: 0 10px 0px 0;
}
div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}
.paddingBottom {
  padding-bottom: 35px;
  color: #82848a;
  border-bottom: 1px solid #82848a;
}

.ProductCaseDetail_text1 {
  text-align: center;
  font-size: 24px;
  color: #333333;
  padding-bottom: 64px;
}

.ProductCaseDetail_text2 {
  border-bottom: 1px solid #82848a;
}
.ProductCaseDetail_text2 div {
  font-size: 20px;
  color: #2968bd;
}
.ProductCaseDetail_text2 p {
  padding-top: 30px;
  font-size: 14px;
  color: #666666;
  text-indent: 2em;
  line-height: 25px;
}

.ProductCaseDetail_text3 div {
  color: #2968bd;
  padding: 20px 0;
  font-size: 20px;
}

.ProductCaseDetail_text3 p {
  text-indent: 2em;
  color: #666666;
  font-size: 14px;
  line-height: 25px;
}

.ProductCaseDetail_text4_txt {
  font-size: 20px;
  padding: 20px 0;
  color: #2968bd;
}

.ProductCaseDetail_text4 p {
  text-indent: 1em;
  font-size: 14px;
  padding-bottom: 5px;
  color: #666666;
  line-height: 25px;
}

.ProductCaseDetail_text5_flex {
  display: flex;
  /*flex-direction: column;*/
  justify-content: center;
  align-items: center;
}
.ProductCaseDetail_text5 div {
  color: #2968bd;
  font-size: 20px;
  padding: 20px 0;
}

.ProductCaseDetail_text5_img {
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  align-items: center;
  /*width: 36%;*/
  width: 520px;
  height: 300px;
}
.ProductCaseDetail_text5_img img {
  width: 100%;
  height: 100%;
}
/* .ProductCaseDetail_text5_img div {
  padding: 2px;
} */
.ProductCaseDetail_text6_txt {
  font-size: 20px;
  padding: 20px 0;
  color: #2968bd;
}
.ProductCaseDetail_text6 p {
  font-size: 14px;
  padding-bottom: 5px;
  text-indent: 1em;
  color: #666666;
  line-height: 25px;
}
.ProductCaseDetail_text7_txt {
  font-size: 20px;
  padding: 20px 0;
  color: #2968bd;
}
.ProductCaseDetail_text7 p {
  text-indent: 1em;
  padding-top: 10px;
  font-size: 14px;
  color: #666666;
  line-height: 25px;
}
.ToParkKeeper {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/ProductCaseDetail.vue